export default {
      id: "hourglass-solid-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#hourglass-solid",
      toString: function () {
        return this.url;
      }
    }